import * as React from 'react';

import BlueprintSelect from './blueprint-select-field';
import BuieSelect from './buie-select-field';
import { useShouldRenderBlueprint } from '../../useShouldRenderBlueprint';
import VariantComponent from '../../variant-component';

type Props = {
  className?: string;
  description?: React.ReactNode;
  error?: React.ReactNode | string;
  infoText?: React.ReactNode | string;
  isDisabled?: boolean;
  isInTwoColumn?: boolean;
  /** Chooses between MultiSelectFieldPrimitive and SingleSelectFieldPrimitive */
  isMultiple?: boolean;
  isRequired?: boolean;
  label: React.ReactNode;
  maximumSelections?: number;
  onChange: (...args: unknown[]) => unknown;
  options: Array<string>;
  selectedValues: Array<string>;
  isSubmitter?: boolean;
};

const SelectField = React.memo<Props>((props: Props) => {
  // Should be addressed in FORMS-21207
  const shouldRenderBlueprint = useShouldRenderBlueprint();

  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintSelect}
      OldComponent={BuieSelect}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
});

SelectField.displayName = 'SelectField';

export type SelectFieldProps = Props;
export { SelectField };
export default SelectField;
